import { IFRAMELY_API_KEY } from 'util/constants';

import { externalUrlFetcher } from './utils';

export interface IframelyResponse {
  html: string;
  meta: { description?: string; title?: string; medium?: string; canonical?: string; site?: string };
  links: {
    thumbnail?: { href: string; type: string; media: { width: number; height: number } }[];
    icon?: { href: string }[];
  };
}

// iframe.ly is a third party: plain fetch, not ApiBase, so the access token axios carries as a global default stays home
export const IframelyApi = () => ({
  get: (url: string): Promise<IframelyResponse> =>
    externalUrlFetcher(
      `https://iframe.ly/api/iframely?url=${encodeURI(url)}&api_key=${IFRAMELY_API_KEY}&iframe=1&omit_css=1&omit_script=1`,
    ),
});
